import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { userContext } from "../../App";
import "./Header.css";
const Header = () => {
  const [signInUser, setSignInUser] = useContext(userContext);
  return (
    <div>
      <ul class="nav justify-content-end pt-5">
        <li class="nav-item">
          <Link
            style={{ color: "white" }}
            class="nav-link active"
            aria-current="page"
            to="/home"
          >
            Home
          </Link>
        </li>
        <li class="nav-item">
          <Link style={{ color: "white" }} class="nav-link" to="/login">
            Blog
          </Link>
        </li>
        <li class="nav-item">
          <Link style={{ color: "white" }} class="nav-link" to="/login">
            Destination
          </Link>
        </li>
        <li class="nav-item">
          <Link
            style={{ color: "white" }}
            class="nav-link disabled"
            to="/login"
          >
            Contact
          </Link>
        </li>
        <li class="nav-item">
          {signInUser.name ? (
            <Link
              style={{
                color: "white",
                backgroundColor: "tomato",
                borderRadius: "5px",
              }}
              class="nav-link disabled"
              to="/login"
            >
              {signInUser.name}
            </Link>
          ) : (
            <Link
              style={{
                color: "white",
                backgroundColor: "tomato",
                borderRadius: "5px",
              }}
              class="nav-link disabled"
              to="/login"
            >
              Log In
            </Link>
          )}
        </li>
      </ul>
    </div>
  );
};

export default Header;
